import React, {
  useState,
  useContext
} from 'react';
import {
  Grid,
  makeStyles,
  Button as Botao
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import Input from '../../../shared/component/FormElements/Input';
import Seletor from '../../../shared/component/FormElements/Seletor';
import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_CPF,
  VALIDATOR_CNPJ
} from '../../../utils/validators';
import { useForm } from '../../../hooks/form-hook';
import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../shared/context/auth-context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
  },
  removerholder: {
    overflowY: 'unset',
  },
}));

const Autocompletex = (props) => {
  const {
    opcoes = [],
    id,
    label,
    fullWidth,
    variant,
    selecionado,
    onChange,
    InputLabelProps,
    disabled
  } = props;
  const auth = useContext(AuthContext);
  const add = auth.userPermission.permissoes.includes('create_doadores') || auth.userPermission.nome === 'Gestor do Sistema';
  const classes = useStyles();
  const filter = createFilterOptions();
  const [value, setValue] = useState(selecionado !== undefined ? selecionado : null);
  const [open, toggleOpen] = useState(false);
  const [dialogValue, setDialogValue] = useState({ nome: '', tipo: '', documento: '' });
  const tipos = [{ label: 'Pessoa Física', id: 'CPF' }, { label: 'Pessoa Jurídica', id: 'CNPJ' }];
  const {
    isLoading,
    error,
    sendRequest,
    clearError,
  } = useHttpClient();
  const [formState, inputHandler, setFormData] = useForm({
    nome: {
      value: '',
      isValid: true
    },
    tipo: {
      value: 'CPF',
      isValid: true
    },
    documento: {
      value: '',
      isValid: false
    }
  }, false);

  const handleClose = () => {
    setDialogValue({
      nome: '',
      tipo: '',
      documento: ''
    });

    toggleOpen(false);
  };

  const mudar = async () => {
    setFormData(
      {
        ...formState.inputs,
        documento: {
          value: '',
          isValid: false
        },
      },
      false
    );
  };

  const handleSubmit = async () => {
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/doadores`,
        'POST',
        JSON.stringify({
          nome: formState.inputs.nome.value,
          tipo: formState.inputs.tipo.value,
          documento: formState.inputs.documento.value,
        }),
        {
          'x-access-token': auth.token,
          'Content-Type': 'application/json'
        }
      );
      if (response.sucesso) {
        setValue(response.data);
        onChange(response.data);
        handleClose();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Autocomplete
        options={opcoes}
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue({
                nome: newValue,
                tipo: '',
                documento: '',
              });
            });
          } else if (newValue && newValue.inputValue) {
            toggleOpen(true);
            setDialogValue({
              nome: newValue.inputValue,
              tipo: '',
              documento: '',
            });
          } else {
            setValue(newValue);
            onChange(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (params.inputValue !== '' && add) {
            filtered.push({
              inputValue: params.inputValue,
              nome: `Adicionar "${params.inputValue}"`,
            });
          }

          return filtered;
        }}
        getOptionLabel={(option) => {
          // e.g value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.nome;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(option) => option.nome}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth={fullWidth}
            label={label}
            id={id}
            margin="normal"
            disabled={disabled}
            // InputProps={InputProps}
            variant={variant}
            InputLabelProps={InputLabelProps}
          />
        )}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={(event) => event.preventDefault()}>
          <DialogTitle id="form-dialog-title">Adicionar novo Doador</DialogTitle>
          <DialogContent className={classes.removerholder}>
            <DialogContentText>
              Informe os dados do doador abaixo.
            </DialogContentText>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Input
                  id="nome"
                  element="input"
                  type="text"
                  label="Nome do Doador"
                  fullWidth
                  initialValue={dialogValue.nome}
                  initialValid
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText="Insira um nome."
                  onInput={inputHandler}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Seletor
                  id="tipo"
                  name="tipo"
                  onInput={inputHandler}
                  label="Tipo"
                  placeholder="Tipo"
                  blank="Selecione"
                  fullWidth
                  variant="outlined"
                  data={tipos}
                  onChange={mudar}
                  errorText="Informe o tipo do documento."
                  validators={[VALIDATOR_REQUIRE()]}
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  id="documento"
                  element="input"
                  type="text"
                  label={formState.inputs.tipo.value === 'CPF' ? 'CPF' : 'CNPJ'}
                  fullWidth
                  validators={[VALIDATOR_REQUIRE(), formState.inputs.tipo.value === 'CPF' ? VALIDATOR_CPF() : VALIDATOR_CNPJ()]}
                  errorText={formState.inputs.tipo.value === 'CPF' ? 'Insira um CPF válido.' : 'Insira um CNPJ válido.'}
                  onInput={inputHandler}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            {isLoading && <LoadingSpinner asOverlay />}
            <ErrorMessage error={error} onClear={clearError} />
          </DialogContent>
          <DialogActions>
            <Botao onClick={handleClose} color="primary">
              Cancelar
            </Botao>
            <Botao
              color="secondary"
              disabled={!formState.isValid}
              size="large"
              type="button"
              variant="contained"
              marginBottom={5}
              onClick={handleSubmit}
              className={classes.button}
            >
              Salvar
            </Botao>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
export default Autocompletex;
